export default __webpack_public_path__ + "static/media/light_rank1.657579fe.svg";